import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/jortsoft-logo.png'
import _imports_1 from '@/assets/jortsoft_text_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-191a9a10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cont container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  draggable: "false",
  src: _imports_0,
  class: "long",
  alt: "Jortsoft long logo"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  draggable: "false",
  src: _imports_1,
  class: "short",
  alt: "Jortsoft text logo"
}, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "right-side" }
const _hoisted_6 = { class: "menus" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_9 = { class: "uppercase" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "13",
    height: "10",
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0.874992 9.875L12.125 9.875C12.2389 9.87465 12.3505 9.84323 12.4479 9.78414C12.5453 9.72505 12.6247 9.64053 12.6776 9.53966C12.7305 9.43879 12.7549 9.3254 12.7482 9.2117C12.7414 9.098 12.7038 8.98829 12.6394 8.89438L7.01437 0.76938C6.78124 0.432505 6.21999 0.432505 5.98624 0.76938L0.361242 8.89438C0.296133 8.98809 0.257951 9.09786 0.250846 9.21175C0.24374 9.32564 0.267982 9.4393 0.320939 9.54038C0.373895 9.64146 0.45354 9.7261 0.55122 9.78509C0.6489 9.84409 0.76088 9.87518 0.874992 9.875Z",
      fill: "black"
    })
  ])
], -1))
const _hoisted_11 = { class: "uppercase" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "29",
  height: "21",
  viewBox: "0 0 29 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.375 1.75H27.625M1.375 10.5H27.625M1.375 19.25H27.625",
    stroke: "black",
    "stroke-width": "2.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "popup" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "30",
  height: "30",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z",
    fill: "black"
  })
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "menu-cont" }
const _hoisted_18 = { class: "menus" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "13",
    height: "10",
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0.874992 9.875L12.125 9.875C12.2389 9.87465 12.3505 9.84323 12.4479 9.78414C12.5453 9.72505 12.6247 9.64053 12.6776 9.53966C12.7305 9.43879 12.7549 9.3254 12.7482 9.2117C12.7414 9.098 12.7038 8.98829 12.6394 8.89438L7.01437 0.76938C6.78124 0.432505 6.21999 0.432505 5.98624 0.76938L0.361242 8.89438C0.296133 8.98809 0.257951 9.09786 0.250846 9.21175C0.24374 9.32564 0.267982 9.4393 0.320939 9.54038C0.373895 9.64146 0.45354 9.7261 0.55122 9.78509C0.6489 9.84409 0.76088 9.87518 0.874992 9.875Z",
      fill: "black"
    })
  ])
], -1))

import { ComputedRef, Ref, computed, onMounted, ref } from 'vue';
import { store } from '@/store/store'
import headerGEO from '@/jsons/headerGEO.json'
import headerENG from '@/jsons/headerENG.json'
import { scrollSection } from "@/modules/scrollTo"
import { useRoute, useRouter } from 'vue-router';

const modalCloseTime: number = 580;
const scrollTime: number = 1500;

export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const Store = store();
const router = useRouter();
const route = useRoute();

const langSelectOpen: Ref<boolean> = ref(false);
const modalIsOpen: Ref<boolean> = ref(false);
const modalCloseAnim: Ref<boolean> = ref(false);
const isScrolled: ComputedRef<boolean> = computed(() => Store.getIsScroll)

let modalCloseTimeOut: number | undefined = undefined;
let navTimeOut: number | undefined = undefined;
let scrollTimeOut: number | undefined = undefined;
let onloadTimeOut: number | undefined = undefined;

const currentLangCode: ComputedRef<string | null> = computed(() => Store.getCurrentLang);
const secondLangCode: ComputedRef<string | undefined> = computed(() => Store.getLangCodes.find((item) => item.toUpperCase() !== currentLangCode.value))
const menuItems: ComputedRef<{ text: string }[]> = computed(() => Store.getCurrentLang === 'GE' ? headerGEO : headerENG)

// CUSTOM FUNCTIONS
const closeModal = (): void => {
    modalCloseAnim.value = true;
    window.clearTimeout(modalCloseTimeOut);
    modalCloseTimeOut = window.setTimeout(() => {
        modalIsOpen.value = false;
        modalCloseAnim.value = false;
    }, modalCloseTime)
}
const changeLang = (): void => {
    Store.changeCurrentLang(secondLangCode.value?.toUpperCase() as string)
    langSelectOpen.value = false;
}
const menuClick = (index: number, close: boolean): void => {
    let target;
    if (index === 0) {
        target = document.querySelector('#productSection')
    } else if (index === 1) {
        target = document.querySelector('#newsSection')
    } else if (index === 2) {
        target = document.querySelector('#aboutSection')
    } else if (index === 3) {
        target = document.querySelector('#supportSection')
    }
    if (close) closeModal();
    if (target) {
        router.push({ query: { section: target.id } })
        scrollSection(target)
    } else {
        if (index === 0) {
            target = 'productSection';
        } else if (index === 1) {
            target = 'newsSection';
        } else if (index === 2) {
            target = 'aboutSection';
        } else if (index === 3) {
            target = 'supportSection';
        }
        navigateHome(target);
    }
}
const navigateHome = (section: string | null | undefined): void => {
    Store.setIsNavigate(true);
    window.clearTimeout(navTimeOut)
    navTimeOut = window.setTimeout(() => {
        router.push({ path: '/home', query: { section: section } });
    }, Store.getNavLoaderTime + 200)

    if (section) {
        window.clearTimeout(scrollTimeOut);
        scrollTimeOut = window.setTimeout(() => {
            setDefSection();
        }, Store.getNavLoaderTime + scrollTime);
    }
}

const setDefSection = (): void => {
    const target = document.querySelector(`#${route.query.section}`);
    scrollSection(target)
}
onMounted(() => {
    window.clearTimeout(onloadTimeOut);
    onloadTimeOut = window.setTimeout(() => {
        setDefSection();
    }, Store.getNavLoaderTime + scrollTime);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass({ scrolled: !isScrolled.value })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "left-side pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateHome(null)))
      }, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "menu-item pointer",
              onClick: ($event: any) => (menuClick(index, false))
            }, [
              _createElementVNode("p", null, _toDisplayString(item.text), 1),
              _hoisted_8
            ], 8, _hoisted_7))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["lang-select pointer", { open: langSelectOpen.value }])
        }, [
          _createElementVNode("div", {
            class: "top-cont",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (langSelectOpen.value = !langSelectOpen.value))
          }, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(currentLangCode.value), 1),
            _hoisted_10
          ]),
          _createElementVNode("div", {
            class: "bottom-cont",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (changeLang()))
          }, [
            _createElementVNode("p", _hoisted_11, _toDisplayString(secondLangCode.value), 1)
          ])
        ], 2),
        _createElementVNode("button", {
          class: "center burger",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (modalIsOpen.value = true))
        }, _hoisted_13)
      ])
    ]),
    (modalIsOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["modal", { close: modalCloseAnim.value }])
        }, [
          _createElementVNode("div", {
            class: "outdide-mask",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (closeModal()))
          }),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              class: "center close",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (closeModal()))
            }, _hoisted_16),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "menu-item pointer",
                    onClick: ($event: any) => (menuClick(index, true))
                  }, [
                    _createElementVNode("p", null, _toDisplayString(item.text), 1),
                    _hoisted_20
                  ], 8, _hoisted_19))
                }), 128)),
                _createElementVNode("div", {
                  class: _normalizeClass(["lang-select pointer mobile", { open: langSelectOpen.value }])
                }, [
                  _createElementVNode("div", {
                    class: "top-cont",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (langSelectOpen.value = !langSelectOpen.value))
                  }, [
                    _createElementVNode("p", null, _toDisplayString(currentLangCode.value), 1),
                    _hoisted_21
                  ]),
                  _createElementVNode("div", {
                    class: "bottom-cont",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (changeLang()))
                  }, [
                    _createElementVNode("p", null, _toDisplayString(secondLangCode.value), 1)
                  ])
                ], 2)
              ])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})